// app/assets/javascripts/react/ducks/clarityTuitionApiUsers.js
import { actionize, apiFetch, apiAction } from 'utils';
import DuckEntity from './DuckEntity';

class ClarityTuitionApiUserDuckEntity extends DuckEntity {
  constructor(name) {
    super(name);
  }
}

const baseEntity = new ClarityTuitionApiUserDuckEntity('clarityTuitionApiUsers');

let types = {
  DESTROY_ALL_USERS: null,
  DESTROY_ALL_USERS_SUCCESS: null,
  DESTROY_ALL_USERS_FAIL: null
};
types = actionize(types, (action) => `schooladmin/clarityTuitionApiUsers/${action}`);

const destroyAllUsers = () => {
  return apiAction(
    types.DESTROY_ALL_USERS,
    types.DESTROY_ALL_USERS_SUCCESS,
    types.DESTROY_ALL_USERS_FAIL,
    (state) => apiFetch.delete(
      state,
      `${baseEntity.config.apiPath}/destroy_all`,
      {}
    ),
    {entityName: baseEntity.name, create: false, update: true},
    {form: baseEntity.schema}
  );
};

export const entity = {
  ...baseEntity,
  actions: {
    ...baseEntity.actions,
    destroyAllUsers
  }
};

export default baseEntity.reducer;
